import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { FILE_INPUT_ACCEPT } from "src/shared/api-types/file";

import Button from "../../components/Button";
import { Form, DatePicker, FileInput, Textarea, Validation, InputForm } from "../../components/Form";
import { StyledPaper } from "../../components/Base";
import { fireEvent } from "../../hooks/usePubsub";
import { uploadWrittenTest } from "../../api/training.deprecated";

const validation = {
  certificateFile: Validation.required,
  validAnswer: Validation.required,
  completedDate: Validation.noop,
  comment: Validation.noop,
};

const MAX_FILE_SIZE = 1024 * 1024 * 10; // 10 Mb

const WrittenTestTraining = ({ match, history }) => {
  const { t } = useTranslation();
  const trainingId = match.params.trainingId;
  const userId = match.params.userId;

  const submit = async (values) => {
    if (values.certificateFile[0]?.size >= MAX_FILE_SIZE) {
      return {
        certificateFile: t("file_too_large_10mb"),
      };
    }

    const result = await uploadWrittenTest({
      userId,
      trainingId,
      validAnswer: values.validAnswer,
      files: values.certificateFile,
      completedDate: values.completedDate,
      comment: values.comment,
    });

    if (result.status === "ok") {
      history.goBack();
      fireEvent("pending-changed");
      return null;
    } else {
      console.log("error");
      return result?.reason;
    }
  };

  return (
    <StyledPaper variant="outlined">
      <Form onSubmit={submit} validation={validation}>
        <Box
          sx={{
            m: 2,
          }}
        >
          <Typography variant="subtitle1">{t("training_pages.written_test_upload")}</Typography>
        </Box>
        <Box
          sx={{
            m: 2,
          }}
        >
          <Box
            sx={{
              display: "inline-block",
            }}
          >
            <InputForm name="validAnswer" label={t("training_pages.valid_answer")} />
          </Box>
        </Box>

        <Box
          sx={{
            m: 2,
          }}
        >
          <FileInput
            name="certificateFile"
            accept={FILE_INPUT_ACCEPT}
            label={t("certificate_upload.certificate_file_required")}
          />
        </Box>

        <Box
          sx={{
            m: 2,
          }}
        >
          <Box
            sx={{
              marginRight: "1rem",
              display: "inline-block",
            }}
          >
            <DatePicker name="completedDate" label={t("training_pages.complete_date_required")} />
          </Box>
        </Box>
        <Box
          sx={{
            m: 2,
          }}
        >
          <Textarea name="comment" label={t("comment")} rows={5} />
        </Box>
        <Box
          sx={{
            m: 2,
          }}
        >
          <Button type="submit" title={t("training_pages.save_certificate")}>
            {t("save")}
          </Button>
          <Button title={t("back")} onClick={() => history.goBack()}>
            {t("cancel")}
          </Button>
        </Box>
      </Form>
    </StyledPaper>
  );
};
export default WrittenTestTraining;
